import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import { Container, Form, Grid, Image, Message, Segment } from 'semantic-ui-react'

import ComponentContainer from './SignInModuleContainer'
import Enhancer from './SignInModuleEnhancer'

import Button from 'Components/StandardButton'

import * as styles from './styles'

import logo from 'Global/Assets/jk_logo.png'

const SignInModule = props => {
  const { email, handleInputChange, handleSubmit, hasError, isPending, password } = props

  return (
    <Container style={styles.container} fluid>
      <Grid centered stackable>
        <Grid.Column width={4}>
          <Image size="small" src={logo} centered />
          <br />
          <br />

          <Segment.Group>
            <Segment loading={isPending}>
              {hasError ? <Message content="Wrong email or password. Please try again." header="An Error Occured." error /> : ''}

              <Form onSubmit={handleSubmit}>
                <Form.Field>
                  <Form.Input
                    icon="mail"
                    iconPosition="left"
                    name="email"
                    onChange={handleInputChange}
                    placeholder="Email"
                    type="email"
                    value={email}
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    icon="lock"
                    iconPosition="left"
                    name="password"
                    onChange={handleInputChange}
                    placeholder="password"
                    type="password"
                    value={password}
                  />
                </Form.Field>

                <div style={styles.alignRight}>
                  <Button content="Sign In" icon="sign in" error={hasError} loading={isPending} />
                </div>
              </Form>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid>
    </Container>
  )
}

SignInModule.propTypes = {
  email: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  user: PropTypes.object,
}

const composed = compose(
  Enhancer,
  ComponentContainer,
)

export default composed(SignInModule)
